import { Brand, createBranded } from '@deltasierra/type-utilities';

export type DateTimeString = Brand<string, 'DateTime'>;
export const DateTimeString = createBranded<DateTimeString>();
